// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nj-c";
export var backButton = "_nj-4";
export var backIcon = "_nj-5";
export var chevronShortcut = "_nj-6";
export var container = "_nj-1";
export var editor = "_nj-8";
export var editorWrapper = "_nj-7";
export var prefix = "_nj-2";
export var searchIcon = "_nj-3";
export var suffix = "_nj-9";
export var suffixContent = "_nj-a";
export var suffixText = "_nj-b";
export var wrapper = "_nj-0";